// src/utils/permissions.ts
export const can = (userRole: string, action: string): boolean => {
  if (userRole === 'SYSTEM_ADMIN') return true;

  const matrix: Record<string, string[]> = {
    'create_announcement': ['OWNER', 'ADMIN', 'MODERATOR'],
    'send_email_blast':    ['OWNER', 'ADMIN'],
    'manage_members':      ['OWNER', 'ADMIN'],
    'view_ledger':         ['OWNER', 'ADMIN', 'TREASURER'],
    'configure_fees':      ['OWNER', 'ADMIN'],
    'verify_requirement':  ['OWNER', 'ADMIN', 'EVALUATOR', 'REF'],
    'create_event':        ['OWNER', 'ADMIN', 'MODERATOR', 'REF'],
    'create_poll':         ['OWNER', 'ADMIN', 'MODERATOR'],
    'manage_vault':        ['OWNER', 'ADMIN'],
    'view_analytics':      ['OWNER', 'ADMIN'],
    'edit_settings':       ['OWNER', 'ADMIN'],
  };
  return matrix[action]?.includes(userRole) ?? false;
};
